// Translations
import accessKeyDeletionDialog from '../components/access-key-deletion-dialog/translations/ru'

// Translation: Account > Integrations > Access keys (Russian)
export default Object.freeze({
	components: { accessKeyDeletionDialog },
	fallback: '',
	subtitle: '',
	table: {
		fields: {
			actions: {
				label: ''
			},
			creationDate: {
				label: ''
			},
			creator: {
				label: ''
			},
			expirationDate: {
				fallback: '∞',
				label: ''
			},
			key: {
				label: ''
			},
			name: {
				fallback: '',
				label: ''
			},
			type: {
				admin: '',
				label: '',
				member: ''
			}
		}
	},
	title: ''
})
